var render = function render(){var _vm=this,_c=_vm._self._c;return _c('identity-provider-form',{attrs:{"errors":_vm.errors,"model":_vm.identity_provider,"title":"New Identity Provider","action":"createIdentityProvider"},on:{"createIdentityProvider":_vm.createIdentityProvider}})
}
var staticRenderFns = []

export { render, staticRenderFns }